import React, { useState, useEffect } from 'react';
import {
  getSectores,
  getSedesActivas,
  crearSector,
  actualizarSector,
  eliminarSector,
  getEstadisticasSector,
} from '../../services/api';

function Sectores() {
  const [sectores, setSectores] = useState([]);
  const [sedes, setSedes] = useState([]);
  const [sedeSeleccionada, setSedeSeleccionada] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showStatsModal, setShowStatsModal] = useState(false);
  const [editando, setEditando] = useState(null);
  const [estadisticas, setEstadisticas] = useState(null);
  const [formData, setFormData] = useState({
    sedeId: '',
    nombre: '',
    codigo: '',
    activo: true,
  });
  const [mensaje, setMensaje] = useState(null);

  useEffect(() => {
    cargarSedes();
  }, []);

  useEffect(() => {
    if (sedeSeleccionada) {
      cargarSectores();
    }
  }, [sedeSeleccionada]);

  const cargarSedes = async () => {
    try {
      const res = await getSedesActivas();
      setSedes(res.data);
      if (res.data.length > 0 && !sedeSeleccionada) {
        setSedeSeleccionada(res.data[0].id.toString());
      }
    } catch (error) {
      console.error('Error cargando sedes:', error);
      mostrarMensaje('Error al cargar sedes', 'error');
    }
  };

  const cargarSectores = async () => {
    try {
      const res = await getSectores({ sedeId: sedeSeleccionada });
      setSectores(res.data);
    } catch (error) {
      console.error('Error cargando sectores:', error);
      mostrarMensaje('Error al cargar sectores', 'error');
    }
  };

  const abrirModal = (sector = null) => {
    if (sector) {
      setEditando(sector.id);
      setFormData({
        sedeId: sector.sede_id,
        nombre: sector.nombre,
        codigo: sector.codigo,
        activo: sector.activo,
      });
    } else {
      setEditando(null);
      setFormData({
        sedeId: sedeSeleccionada || '',
        nombre: '',
        codigo: '',
        activo: true,
      });
    }
    setShowModal(true);
  };

  const cerrarModal = () => {
    setShowModal(false);
    setEditando(null);
    setFormData({
      sedeId: '',
      nombre: '',
      codigo: '',
      activo: true,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editando) {
        await actualizarSector(editando, formData);
        mostrarMensaje('Sector actualizado exitosamente', 'success');
      } else {
        await crearSector(formData);
        mostrarMensaje('Sector creado exitosamente', 'success');
      }
      cerrarModal();
      cargarSectores();
    } catch (error) {
      console.error('Error guardando sector:', error);
      mostrarMensaje(
        error.response?.data?.error || 'Error al guardar sector',
        'error'
      );
    }
  };

  const handleEliminar = async (id, nombre) => {
    if (!window.confirm(`¿Estás seguro de desactivar el sector "${nombre}"?`)) {
      return;
    }

    try {
      await eliminarSector(id);
      mostrarMensaje('Sector desactivado exitosamente', 'success');
      cargarSectores();
    } catch (error) {
      console.error('Error eliminando sector:', error);
      mostrarMensaje(
        error.response?.data?.error || 'Error al desactivar sector',
        'error'
      );
    }
  };

  const verEstadisticas = async (id) => {
    try {
      const res = await getEstadisticasSector(id);
      setEstadisticas(res.data);
      setShowStatsModal(true);
    } catch (error) {
      console.error('Error cargando estadísticas:', error);
      mostrarMensaje('Error al cargar estadísticas', 'error');
    }
  };

  const mostrarMensaje = (texto, tipo) => {
    setMensaje({ texto, tipo });
    setTimeout(() => setMensaje(null), 3000);
  };

  return (
    <div className="container-fluid">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Gestión de Sectores</h2>
        <button className="btn btn-primary" onClick={() => abrirModal()}>
          ➕ Nuevo Sector
        </button>
      </div>

      {mensaje && (
        <div className={`alert alert-${mensaje.tipo === 'success' ? 'success' : 'danger'}`}>
          {mensaje.texto}
        </div>
      )}

      {/* Selector de sede */}
      <div className="card mb-3 shadow-sm">
        <div className="card-body py-3">
          <div className="row align-items-center">
            <div className="col-auto">
              <label className="form-label mb-0 fw-semibold">
                <i className="bi bi-building me-2"></i>
                Filtrar por Sede:
              </label>
            </div>
            <div className="col-md-4">
              <select
                className="form-select form-select-lg"
                value={sedeSeleccionada}
                onChange={(e) => setSedeSeleccionada(e.target.value)}
                style={{
                  borderRadius: '8px',
                  border: '2px solid #dee2e6',
                  fontSize: '1rem',
                  padding: '0.6rem 1rem'
                }}
              >
                {sedes.map((sede) => (
                  <option key={sede.id} value={sede.id}>
                    {sede.nombre} ({sede.codigo})
                  </option>
                ))}
              </select>
            </div>
            <div className="col-auto">
              <span className="badge bg-primary" style={{ fontSize: '0.9rem', padding: '0.5rem 1rem' }}>
                {sectores.length} sector{sectores.length !== 1 ? 'es' : ''}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Código</th>
                  <th>Nombre</th>
                  <th>Sede</th>
                  <th>Estado</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {sectores.length === 0 ? (
                  <tr>
                    <td colSpan="5" className="text-center text-muted">
                      No hay sectores registrados para esta sede
                    </td>
                  </tr>
                ) : (
                  sectores.map((sector) => (
                    <tr key={sector.id}>
                      <td>
                        <span className="badge bg-secondary">{sector.codigo}</span>
                      </td>
                      <td>{sector.nombre}</td>
                      <td>
                        <small className="text-muted">
                          {sector.sede_nombre} ({sector.sede_codigo})
                        </small>
                      </td>
                      <td>
                        {sector.activo ? (
                          <span className="badge bg-success">Activo</span>
                        ) : (
                          <span className="badge bg-secondary">Inactivo</span>
                        )}
                      </td>
                      <td>
                        <button
                          className="btn btn-sm btn-info me-2"
                          onClick={() => verEstadisticas(sector.id)}
                          title="Ver estadísticas"
                        >
                          📊
                        </button>
                        <button
                          className="btn btn-sm btn-warning me-2"
                          onClick={() => abrirModal(sector)}
                          title="Editar"
                        >
                          ✏️
                        </button>
                        {sector.activo && (
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() => handleEliminar(sector.id, sector.nombre)}
                            title="Desactivar"
                          >
                            🗑️
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Modal de formulario */}
      {showModal && (
        <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {editando ? 'Editar Sector' : 'Nuevo Sector'}
                </h5>
                <button type="button" className="btn-close" onClick={cerrarModal}></button>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">Sede *</label>
                    <select
                      className="form-select"
                      value={formData.sedeId}
                      onChange={(e) => setFormData({ ...formData, sedeId: e.target.value })}
                      required
                      disabled={editando}
                    >
                      <option value="">Seleccione una sede</option>
                      {sedes.map((sede) => (
                        <option key={sede.id} value={sede.id}>
                          {sede.nombre} ({sede.codigo})
                        </option>
                      ))}
                    </select>
                    {editando && (
                      <small className="text-muted">No se puede cambiar la sede de un sector existente</small>
                    )}
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Nombre *</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.nombre}
                      onChange={(e) => setFormData({ ...formData, nombre: e.target.value })}
                      required
                      placeholder="Ej: Producción, Administración, Ventas"
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Código *</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.codigo}
                      onChange={(e) => setFormData({ ...formData, codigo: e.target.value.toUpperCase() })}
                      required
                      maxLength="20"
                      placeholder="Ej: PROD, ADMIN, VENTAS"
                    />
                    <small className="text-muted">Código corto para etiquetas e identificación</small>
                  </div>
                  <div className="mb-3 form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="activo"
                      checked={formData.activo}
                      onChange={(e) => setFormData({ ...formData, activo: e.target.checked })}
                    />
                    <label className="form-check-label" htmlFor="activo">
                      Sector activo
                    </label>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={cerrarModal}>
                    Cancelar
                  </button>
                  <button type="submit" className="btn btn-primary">
                    {editando ? 'Actualizar' : 'Crear'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Modal de estadísticas */}
      {showStatsModal && estadisticas && (
        <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Estadísticas - {estadisticas.sector} ({estadisticas.sede})
                </h5>
                <button type="button" className="btn-close" onClick={() => setShowStatsModal(false)}></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-4 mb-3">
                    <div className="card text-center">
                      <div className="card-body">
                        <h3>{estadisticas.estadisticas.usuarios}</h3>
                        <p className="mb-0">Usuarios</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-4 mb-3">
                    <div className="card text-center">
                      <div className="card-body">
                        <h3>{estadisticas.estadisticas.pedidosHoy}</h3>
                        <p className="mb-0">Pedidos Hoy</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-4 mb-3">
                    <div className="card text-center">
                      <div className="card-body">
                        <h3>{estadisticas.estadisticas.pedidosMes}</h3>
                        <p className="mb-0">Pedidos Este Mes</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowStatsModal(false)}>
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Sectores;
